import { Route, Routes } from "react-router-dom"
import SerialFrequencyManagement from '../Library/views/BackStage/serial_frequency_management'
import SerialCodeManagement from '../Library/views/BackStage/serial_code_management'
import SerialsManagement from '../Library/views/BackStage/serials_management'
import FrameworkManagement from "./views/framework_management"
import TagStructureManagement from "./views/tag_structure_management"
import SubfieldStructureManagement from "./views/subfield_structure_management"
import SerialReceive from "./views/serial_receive"
import { useEffect } from "react"
import SerialOrderlist from "./views/serial_orderlist"
import ScrappedList from "./views/scrapped_list"
import GeneralBibliographicEditMode from './views/general_bibliographic_edit_mode'
import DuplicateCheckV2 from "./views/duplicate_check_v2"
import DuplicateCheck from "./views/duplicate_check"
import BookImageUpload from "./views/book_image_upload"
import { TotalHoldings } from "./views/total_holdings"
import { HoldingsAdded } from "./views/holdings_added"
import { HoldingsRemoved } from "./views/holdings_removed"
import Z3950Document1 from "./views/z3950_document_1.jsx"
import Z3950Document2 from "./views/z3950_document_2.jsx"
import Z3950Document3 from "./views/z3950_document_3.jsx"
import Z3950DocumentResponse1 from "./views/z3950_document_response_1.jsx"
import Z3950DocumentResponse2 from "./views/z3950_document_response_2.jsx"

const allRouteKeys = [
    "bibliographic_management",
    "serial_frequency_management",
    "serial_code_management",
    "serials_management",
    "serial_receive",
    "serial_orderlist_management",
    "framework_management",
    "tag_structure_management",
    "subfield_structure_management",
    "scrapped_list_management",
    "duplicate_check",
    "book_image_upload",
    'total_holdings',
    'holdings_added',
    'holdings_removed',

]
const MainRoute = ({
    user_permission_data = [],
    include = allRouteKeys
}) => {
    const shouldShow = (key) => include.includes(key);

    return (<>
        <Routes>
            {/* 書目 */}
            {shouldShow("bibliographic_management") && (
                <Route path="bibliographic_management" element={<GeneralBibliographicEditMode />} />
            )}
            {/* 期刊 */}
            {shouldShow("serial_frequency_management") && (
                <Route path="serial_frequency_management" element={<SerialFrequencyManagement />} />
            )}
            {shouldShow("serial_code_management") && (
                <Route path="serial_code_management" element={<SerialCodeManagement />} />
            )}
            {shouldShow("serials_management") && (
                <Route path="serials_management" element={<SerialsManagement />} />
            )}
            {shouldShow("serial_receive") && (
                <Route path="serial_receive" element={<SerialReceive  permission_level={user_permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "serial_receive"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
            )}
            {shouldShow("serial_orderlist_management") && (
                <Route path="serial_orderlist_management" element={<SerialOrderlist permission_level={user_permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "serial_orderlist_management"))?.find(data => data !== undefined)?.permission_level_id ?? null}  />} />
            )}
            {/* MARC21 結構管理 */}
            {shouldShow("framework_management") && (
                <Route path="framework_management" element={<FrameworkManagement  permission_level={user_permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "framework_management"))?.find(data => data !== undefined)?.permission_level_id ?? null}/>} />
            )}
            {shouldShow("tag_structure_management") && (
                <Route path="tag_structure_management" element={<TagStructureManagement  permission_level={user_permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "tag_structure_management"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
            )}
            {shouldShow("subfield_structure_management") && (
                <Route path="subfield_structure_management" element={<SubfieldStructureManagement  permission_level={user_permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "subfield_structure_management"))?.find(data => data !== undefined)?.permission_level_id ?? null} />} />
            )}
            {/* 館藏報廢 */}
            {shouldShow("scrapped_list_management") && (
                <Route path="scrapped_list_management" element={<ScrappedList   permission_level={user_permission_data?.map(group => group.permission_data.find(data => data.url.split("/").pop() === "scrapped_list_management"))?.find(data => data !== undefined)?.permission_level_id ?? null}/>} />
            )}
            {/* 複本查核 */}
            {shouldShow("duplicate_check") && (
                <Route path="duplicate_check" element={<DuplicateCheckV2 />} />
            )}
            {/* 書目圖片上傳 */}
            {shouldShow("book_image_upload") && (
                <Route path="book_image_upload" element={<BookImageUpload />} />
            )}
            {/* 館藏報表 */}
            {shouldShow("total_holdings") && (
                <Route path="total_holdings" element={<TotalHoldings />} />
            )}
            {/* 館藏增加量報表 */}
            {shouldShow("holdings_added") && (
                <Route path="holdings_added" element={<HoldingsAdded />} />
            )}
            {/* 館藏淘汰量報表 */}
            {shouldShow("holdings_removed") && (
                <Route path="holdings_removed" element={<HoldingsRemoved />} />
            )}
            {/* z39.50 */}
            {shouldShow("holdings_removed") && (
                <Route path="holdings_removed" element={<HoldingsRemoved />} />
            )}
            {/* z39.50 */}
            {shouldShow("holdings_removed") && (
                <Route path="holdings_removed" element={<HoldingsRemoved />} />
            )}
            {/* z39.50 */}
            {shouldShow("holdings_removed") && (
                <Route path="holdings_removed" element={<HoldingsRemoved />} />
            )}
            {/* z3950欄位管理 */}
            <Route
                path={'z3950_document'}
            >
                {/* 管理首頁 */}
                <Route path={'_1'} element={<Z3950Document1 />} />
                <Route path={'_2'} element={<Z3950Document2 />} />
                {/* 欄位製作編輯 */}
                <Route path={'_3'} element={<Z3950Document3 />} />
            </Route>
            {/* z3950資料管理 */}
            <Route
                path={'z3950_document_response'}
            >
                {/* 管理首頁 */}
                <Route path={'_1'} element={<Z3950DocumentResponse1 />} />
                {/* 名稱建立 */}
                <Route path={'_2'} element={<Z3950DocumentResponse2 />} />
            </Route>


        </Routes>
    </>)
}
export default MainRoute